import { Injectable } from '@angular/core';
import { Fireworks } from 'fireworks-js'

@Injectable({
  providedIn: 'root'
})
export class FireworksService {

  constructor() { }

  playTemporaryFireworks(){
    const container = document.querySelector('.fireworks')
    let fireworks = new Fireworks(container, {
      rocketsPoint: { min: 50, max: 50 },
      hue: { min: 0, max: 360 },
      delay: { min: 15, max: 30 },
      traceSpeed: 2,
      acceleration: 1.10,
      friction: 1.03,
      gravity: 0.5,
      particles: 50,
      trace: 6,
      explosion: 1.5,
      intensity: 10,
      autoresize: true,
      opacity : 0.4 ,
      brightness: {
        min: 50,
        max: 80,
        decay: { min: 0.015, max: 0.03 }
      },
      mouse: {
        click: true,
        move: false,
        max: 3
      },
      boundaries: {
        x: 50,
        y: 50,
        width: window.innerWidth,
        height: window.innerHeight
      },
      sound: {
        enabled: false,
      }
    });
    fireworks.setSize({ width: window.innerWidth, height: window.innerHeight })
    fireworks.start();
    

    setTimeout(() => {
      fireworks.setOptions({ intensity: 0})
    },2800)
    setTimeout(() => {
      fireworks.stop();
      container.innerHTML = "";
    },6000)
  }
}
